<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <p>Quais as empresas que compõem o grupo econômico?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-10 col-xl-10">
        <form @submit="onSubmit">
          <div class="form-row" v-for="(empresa, index) in empresasGrupoEconomico">
            <div class="form-group col-md-6">
              <label for="logradouro">Empresa</label>
              <input type="text" class="form-control form-control-lg" v-model="empresa.RazaoSocial" placeholder="Razão Social" required >
            </div>
            <div class="form-group col-md-5">
              <label for="inputPassword4">CNPJ</label>
              <input type="text" class="form-control form-control-lg" v-model="empresa.Cnpj" v-mask="'cnpj'" pattern="\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}" placeholder="CNPJ" required>
            </div>
            <div class="form-group col-md-1 align-self-center text-center">
              <a @click="removeCorporateGroupCompany(index)" title="Remover empresa" class="icon icon-minus-circle remove"></a>
            </div>
          </div>
          <div class="btns text-center">
            <button type="button" class="btn btn-lg btn-link" @click="addCorporateGroupCompany"><span class="icon icon-plus-circle"></span> Adicionar empresa</button>
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'
import ArrayHelper from '@/utils/array-helper'

export default {
  data() {
    return {
      empresasGrupoEconomico: this.solicitacao.Empresa.EmpresasGrupoEconomico || []
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    validate() {
      if(this.empresasGrupoEconomico.length >= 1) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['Por favor, informe as empresas que fazem parte do grupo econômico']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()
      
      if(validation.isValid) {
        const newData = {
          Empresa: {
            EmpresasGrupoEconomico: this.empresasGrupoEconomico.map(company => {
              return {
                RazaoSocial: company.RazaoSocial,
                Cnpj: Masker.unmaskCnpj(company.Cnpj)
              }
            })
          }
        }
        this.$emit('on-submit', newData)
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    },
    addCorporateGroupCompany() {
      this.empresasGrupoEconomico.push({})
    },
    removeCorporateGroupCompany(index) {
      this.empresasGrupoEconomico.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/CompaniesCorporateGroupStep.vue